import {GROUP_TYPE, GROUP_SECTION_WIDTH, drawBorderLines} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import Util from '../../../../forecast-app/shared/util/util';

class PlaceholderGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_PLACEHOLDER, data);
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH();
		const {data, height} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);

		canvasContext.font = '14px ' + Util.getFontFamily();
		canvasContext.fillStyle = '#a1a1a1';
		canvasContext.font = 'italic 12px ' + Util.getFontFamily();
		canvasContext.fillText(data.name, x + 24, y + 27);

		drawBorderLines(canvasContext, x, y, width, height, true);
	}
}

export default PlaceholderGroup;
